module.exports = __webpack_public_path__ + "media/favicon/android-chrome-192x192-5af1e04ac892f3c46cd43d61ca3ade24.png";